var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreativeCollaborationsIcpon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.324,
    height: 42.324,
    viewBox: "0 0 42.324 42.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idea",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36401",
    "data-name": "Path 36401",
    d: "M3.77,167.29a1.24,1.24,0,0,0-1.24-1.24H1.24a1.24,1.24,0,1,0,0,2.48H2.53A1.24,1.24,0,0,0,3.77,167.29Z",
    transform: "translate(0 -152.323)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36402",
    "data-name": "Path 36402",
    d: "M29.2,23.361a1.241,1.241,0,0,0,.846-2.147l-.943-.88a1.24,1.24,0,0,0-1.691,1.814C28.169,22.77,28.439,23.361,29.2,23.361Z",
    transform: "translate(-24.779 -18.348)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36403",
    "data-name": "Path 36403",
    d: "M28.349,299.693l-.943.88a1.24,1.24,0,1,0,1.691,1.814l.943-.88a1.24,1.24,0,1,0-1.691-1.814Z",
    transform: "translate(-24.779 -274.613)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36404",
    "data-name": "Path 36404",
    d: "M468.927,163.951h-1.29a1.24,1.24,0,0,0,0,2.48h1.29a1.24,1.24,0,0,0,0-2.48Z",
    transform: "translate(-427.843 -150.398)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36405",
    "data-name": "Path 36405",
    d: "M445.662,299.694a1.24,1.24,0,0,0-1.691,1.814l.943.88a1.24,1.24,0,1,0,1.691-1.814Z",
    transform: "translate(-406.909 -274.614)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36406",
    "data-name": "Path 36406",
    d: "M445.663,23.027l.943-.88a1.24,1.24,0,1,0-1.691-1.814l-.943.88a1.24,1.24,0,0,0,1.691,1.814Z",
    transform: "translate(-406.909 -18.347)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36407",
    "data-name": "Path 36407",
    d: "M171,386.777a3.725,3.725,0,0,0,2.285,3.431h9.483a3.724,3.724,0,0,0,2.285-3.431V385H171Z",
    transform: "translate(-156.864 -353.174)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36408",
    "data-name": "Path 36408",
    d: "M201,479.571a1.24,1.24,0,0,0,1.24,1.24h6.613a1.24,1.24,0,0,0,1.24-1.24V478H201Z",
    transform: "translate(-184.384 -438.486)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36409",
    "data-name": "Path 36409",
    d: "M284.106,14.88a6.207,6.207,0,0,0-3.448-10.463A6.2,6.2,0,0,0,271,1.243V29.8h3.72a6.178,6.178,0,0,0,5.951-4.46A6.208,6.208,0,0,0,284.106,14.88ZM273.48,7.523a1.24,1.24,0,0,1,2.48,0c0,1.27.481,1.5,1.44,1.966a3.21,3.21,0,0,1,2.28,2.994,1.24,1.24,0,0,1-2.48,0c0-.272,0-.337-.879-.761a4.224,4.224,0,0,1-2.841-4.2Zm7.355,11.7a6.918,6.918,0,0,1-4.261,2.8,1.24,1.24,0,0,1-.34-2.432,4.858,4.858,0,0,0,2.59-1.818,1.24,1.24,0,1,1,2.011,1.451Z",
    transform: "translate(-248.598 0)",
    fill: "#d750ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36410",
    "data-name": "Path 36410",
    d: "M75.878,29.8V1.243A6.2,6.2,0,0,0,66.22,4.417,6.207,6.207,0,0,0,62.772,14.88,6.208,6.208,0,0,0,66.207,25.34a6.176,6.176,0,0,0,5.951,4.46Zm-6.4-20.312c.959-.463,1.44-.7,1.44-1.966a1.24,1.24,0,0,1,2.48,0,4.224,4.224,0,0,1-2.841,4.2c-.879.424-.879.489-.879.761a1.24,1.24,0,1,1-2.48,0A3.21,3.21,0,0,1,69.478,9.488ZM71.5,21.121a1.241,1.241,0,0,1-1.192.9,6.9,6.9,0,0,1-4.081-2.56,1.24,1.24,0,1,1,1.949-1.533,4.862,4.862,0,0,0,2.472,1.661A1.24,1.24,0,0,1,71.5,21.121Z",
    transform: "translate(-55.956 0)",
    fill: "#d750ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeCollaborationsIcpon);
export default __webpack_public_path__ + "static/media/Creative Collaborations_icpon.dfc88ba4684362b758d6bb871d59e747.svg";
export { ForwardRef as ReactComponent };